<template>
  <div>
    <header>
      <v-toolbar class="app-header elevation-0" fixed app>
        <router-link tag="div" :to="{ name: 'currentEvent' }">
          <v-toolbar-title>
              <div class="logo-img">
                <img draggable="false" src="~@/assets/logo.png">
              </div>
            <span>Messaging Application</span>
          </v-toolbar-title>
        </router-link>
        <v-spacer></v-spacer>
        <router-link 
          tag="v-btn" 
          class="btn--flat hidden-sm-and-down" 
          :to="{ name: 'sectionMessagesAll' }">
          <v-icon color="primary" class="nav-icons">edit</v-icon>
          Messages List
        </router-link>
        <router-link 
          tag="v-btn" 
          class="btn--flat" 
          :to="{ name: 'currentEvent' }">
          <v-icon color="primary" class="nav-icons">home</v-icon>
          Home
        </router-link>
        <v-toolbar-items>
          <v-menu 
            v-if="$route.name !== 'logIn' && $route.name !== 'forgotPassword' && $route.name !== 'newPassword'"
            transition="slide-y-transition"
            class="ml-3 mr-3">
            <v-toolbar-side-icon slot="activator"><v-icon color="primary">person</v-icon></v-toolbar-side-icon>
            <v-list column>  
             <v-btn
               class="btn--flat"  
               @click="logout()"
               ><v-icon left light color="primary">exit_to_app</v-icon>
               Logout
             </v-btn>
             <v-btn
               class="btn--flat"
               :to="{ name: 'profile' }">
               <v-icon left light color="primary">edit</v-icon>
               Edit Profile
             </v-btn>
            </v-list>
          </v-menu>
        </v-toolbar-items>
      </v-toolbar>
    </header>
    <main>
      <v-container fluid grid-list-xl class="content-header">
        <v-flex class="select-section-mobile" xs12>
          <h2 class="headline mb-0" v-if="isEdit">{{message.section ? message.section.name : ''}}</h2>
          <v-select
            v-if="!isEdit && sectionNames.length > 0"
            :items="sectionNames"
            v-model="chosenSection"
            light
            color="primary"
          ></v-select>
        </v-flex>
        <v-layout row justify-space-between wrap>
          <v-flex sm12 md9>
              <h3 class="headline mb-0">Message Configuration</h3>
            <v-layout row justify-space-between wrap class="flex-row">
              <v-flex xs4 sm4 md8 lg2 order-xs1 order-sm1 order-md1 order-lg0 class="padding-off">
                Select Event(s)
              </v-flex>
              <v-flex xs12 sm12 md12 lg8 order-xs0 order-sm0  order-md0 order-lg1 class="padding-off">
                <v-radio-group v-model="filterBy" row class="radio-group">
                  <v-layout row wrap>
                    <v-flex md3 xs6>
                      <v-radio class="radio-btn" label="NFL Games" :value="0"></v-radio>
                    </v-flex>
                    <v-flex md3 xs6>          
                      <v-radio class="radio-btn" label="NCAA Games" :value="1"></v-radio>
                    </v-flex>
                    <v-flex md3 xs6>
                      <v-radio class="radio-btn" label="Other Event" :value="2"></v-radio>
                    </v-flex>
                    <v-flex md3 xs6>
                      <v-radio class="radio-btn" label="All Events" :value="null"></v-radio>
                    </v-flex>
                  </v-layout>
                </v-radio-group>
              </v-flex>
              <v-flex order-xs1 order-sm1 order-md1 order-lg2 class="padding-off">
                <v-checkbox
                  style="width: 120px;"
                  class="checkbox-adjustment"
                  v-model="all"
                  @change="selectAll"
                  label="Select All"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 order-xs2 order-sm2 order-md2 order-lg3 class="table-adjustment">
                <div class="table__overflow">
                  <table class="datatable table">
                    <tbody>
                    <tr class="datatable__progress"><td colspan="100%" class="column"></td></tr>
                      <tr :class="{ 'selectable': event.selectable }" v-for="(event, index) in events" :key="index" v-if="filterBy === null || filterBy === event.type">
                        <td class="text-xs-left">{{event.name}}</td>
                        <td class="text-xs-center">{{getType(event.type)}}</td>
                        <td class="text-xs-center">{{event.start}}</td>
                        <td class="table-chb">
                          <v-checkbox @click="selectEvent(event)" v-model="event.selected"></v-checkbox>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm6 md3 class="img-upload">
            <v-flex class="select-section">
              <h2 class="headline" v-if="isEdit">{{message.section ? message.section.name : ''}}</h2>
              <v-select
                v-if="!isEdit && sectionNames.length > 0"
                :items="sectionNames"
                v-model="chosenSection"
                label="Sections"
                class="mt-2"
                color="primary"
              ></v-select>
            </v-flex>
            <v-card-title class="message-title">Image<v-icon class="up-icon" @click="$refs.upload.click()">file_upload</v-icon></v-card-title>
            <input type="file" accept="image/*" name="thumbnail" @change="onFileChange" ref="upload" style="display: none;">
              <div class="message-img" @click="$refs.upload.click()">
                <img draggable="false" :src="image" alt="">
              </div>
          <div class="btn-wrap">
            <router-link
              tag="v-btn"
              to="/"
            >
              <v-icon left dark>close</v-icon>
              Close
            </router-link>
            <v-btn
              color="primary"
              dark
              @click="submit"
            >
              <v-icon left dark>arrow_forward</v-icon>
              Save
            </v-btn>
          </div>
          </v-flex>
        </v-layout>
        <v-alert color="mt-3 error" icon="warning" v-if="err" :value="err !== ''">{{err}}</v-alert>
        <v-alert color="mt-3 success" icon="check" v-if="success" :value="success !== ''">{{success}}</v-alert>

      </v-container>
    </main>
  </div>
</template>

<script>
  import webHelper from '../../helpers/web';

  export default {
    data: () => ({
      all: false,
      allSelected: false,
      message: {},
      events: [],
      filterBy: null,
      image: null,
      imageFile: null,
      isEdit: false,
      sections: [],
      sectionNames: [],
      chosenSection: {},
      err: '',
      success: '',
    }),
    methods: {
      async logout() {
        const path = process.env.NODE_ENV === 'development' ?
          'http://localhost:3000/logout' : '/logout';
        await webHelper.post(this, path, {});
        this.$store.state.logout();
        this.$router.push({ name: 'logIn' });
      },
      deleteEvent(event, index) {
        this.deleteId = event._id;
        this.deleteIndex = index;
        this.dialogDelete = true;
      },
      selectAll() {
        this.events = this.events.map((event) => {
          const current = event;
          if (!current.selectable) return current;
          if (this.filterBy !== null && this.all) {
            current.selected = event.type === this.filterBy;
            this.allSelected = false;
          } else {
            current.selected = this.all;
            this.allSelected = this.all;
          }
          return current;
        });
      },
      selectEvent(data) {
        if (!data.selectable) return;
        this.events = this.events.map((current) => {
          const event = current;
          if (event._id === data._id) {
            event.selected = !event.selected;
          }
          return event;
        });
        this.all = false;
      },
      getType(type) {
        switch (parseInt(type, 10)) {
          case 0:
            return 'NFL';
          case 1:
            return 'NCAA';
          case 2:
          default:
            return 'Other';
        }
      },
      onFileChange(e) {
        const files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;
        this.createImage(files[0]);
      },
      createImage(file) {
        this.imageFile = file;
        const reader = new FileReader();

        reader.onload = () => {
          this.image = reader.result;
        };
        reader.readAsDataURL(file);
      },
      removeImage() {
        this.image = '';
      },
      async submit() {
        this.err = '';
        const events = [];
        this.events.forEach((event) => {
          if (event.selected) {
            events.push(event._id);
          }
        });
        if (events.length === 0) {
          this.err = 'You need to select at least one event';
          return;
        }
        if (!this.isEdit && !this.imageFile) {
          this.err = 'You need to upload an image';
          return;
        }
        const formData = new FormData();
        let section;
        if (this.isEdit) {
          section = this.message.section._id;
        } else {
          const { _id: id } = this.sections.find(current => current.name === this.chosenSection);
          section = id;
        }
        formData.append('events', events);
        formData.append('section', section);
        if (this.imageFile) {
          formData.append('thumbnail', this.imageFile);
        }
        const method = this.$route.params.id ? 'put' : 'post';
        if (method === 'put') {
          formData.append('id', this.$route.params.id);
        }
        const res = await webHelper[method](this, 'message', formData, true);
        if (res.failed) {
          if (res.body.invalidImg) {
            this.err = 'Image size is invalid. Images must be under 1920px in width, 1080px in height and 500KB in size';
          } else {
            this.err = 'Failed to save the message.';
          }
          return;
        }
        this.image = `${this.$store.state.baseUrl}${this.message.thumbnail}?${Date.now()}`;
        this.success = 'Message saved.';
        setTimeout(() => {
          this.success = '';
        }, 3000);
      },
    },
    watch: {
      filterBy() {
        this.all = this.allSelected;
      },
      async chosenSection(newValue) {
        const section = this.sections.find(current => current.name === newValue);
        const res3 = await webHelper.post(this, 'message/check-events', {
          events: this.events,
          section: section._id,
        });
        this.events = res3.events.map((current) => {
          const event = current;
          event.selected = false;
          return event;
        });
      },
    },
    async created() {
      this.isEdit = !!this.$route.params.id;
      const res2 = await webHelper.get(this, 'event', { from: new Date() });
      if (res2 === null) {
        this.err = 'Failed to get the Events.';
        return;
      }
      if (this.isEdit) {
        const res = await webHelper.get(this, 'message', { id: this.$route.params.id });
        if (res === null) {
          this.err = 'Failed to get the Message.';
          return;
        }
        [this.message] = res.messages;
        const res3 = await webHelper.post(this, 'message/check-events', {
          events: res2.events,
          section: this.message.section,
          id: this.message._id,
        });
        if (res3.failed) {
          this.err = 'Failed to fetch events';
          return;
        }
        this.events = res3.events.map((current) => {
          const event = current;
          let found = false;
          this.message.events.forEach((messageEvent) => {
            if (messageEvent._id === event._id) {
              found = true;
            }
          });
          event.selected = found;
          return event;
        });
      } else {
        const res = await webHelper.get(this, 'section');
        if (res.failed) {
          this.err = 'Failed to get sections';
          return;
        }
        this.sections = res.sections;
        this.sectionNames = res.sections.map(section => section.name);
        this.events = res2.events.map((current) => {
          const event = current;
          event.selected = false;
          return event;
        });
        if (this.$route.query.section) {
          const sectionFrom = this.sections.find(current =>
            current._id === this.$route.query.section);
          this.chosenSection = sectionFrom.name;
        } else {
          this.chosenSection = this.sectionNames[0];
        }
      }
      this.image = this.isEdit ? `${this.$store.state.baseUrl}${this.message.thumbnail}?${Date.now()}` : null;
    },
  };
</script>


<style scoped lang="scss">
  .flex-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
  }
  .radio-group {
    margin: 0 auto !important;
    padding: 0;
    flex-grow: 0.8;
  }
  .table-adjustment {
    padding: 12px 0 !important;
  }
  .img-upload {
    padding: 0 40px 120px 40px !important;
    position: relative;
    .up-icon {
      position: absolute;
      right: 62px;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .message-img {
      max-width: 85%;
      margin: 0 auto;
      overflow: hidden;
      height: auto;
      padding-top: 60%;
      position: relative;
      border: 2px dashed rgba(0,0,0, 0.12);
      &:hover {
        cursor: pointer;
      }
      img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        max-width: 100%;
        height: auto;
      }
    }
  h3 {
    text-transform: uppercase;
  };
  main {
    padding-top: 64px;
  }
  .padding-off {
    padding-bottom: 0 !important;
  }
  .btn {
    margin-right: 0 !important;
  }
  .btn-wrap {
    display: flex;
    flex-direction: column;
    position: absolute;
    right: 62px;
    bottom: 0;
  }
  .checkbox-adjustment {
    margin-left: auto;
  }
  tr:not(.selectable) {
    background: rgba(0,0,0, 0.05);
  }
  .select-section-mobile {
    display: none;
    margin-top: -20px;
  }
  @media only screen and (max-width: 959px) {
    h2 {
      font-size: 14px !important;
    }
  }
  @media only screen and (max-width: 599px) {
    .img-upload {
      padding: 20px 40px 120px !important;
    }
    h2 {
      font-size: 24px !important;
    }
    .select-section {
      display: none;
    }
    .select-section-mobile {
      display: block;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/messages/MessageConfig.vue